module.exports = __webpack_public_path__ + "static/media/extra-button.b27e0a1d.png";